
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[modulo]",
      function () {
        return require("private-next-pages/[modulo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[modulo]"])
      });
    }
  